import Vue from "vue"
import mountLearningPageHero from "./mount"

import getLocale from "@/utils/locale"

export default () => {
  const el = document.querySelector("[id^=learning_page_hero]")

  if (el) {
    const vm = mountLearningPageHero(Vue, { locale: getLocale(), id: el.id })
    vm.$mount(el)
  }
}
